import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "../lib/cn";
export function Input(t0) {
  const $ = _c(10);
  let className;
  let props;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = type;
  } else {
    className = $[1];
    props = $[2];
    type = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("border-input selection:bg-primary selection:text-primary-foreground file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:ring-destructive/40 flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-[3px] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "relative [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-3 [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-60 [&::-webkit-calendar-picker-indicator]:hover:opacity-100 dark:[&::-webkit-calendar-picker-indicator]:invert", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== t1 || $[8] !== type) {
    t2 = <input type={type} data-slot="input" className={t1} {...props} />;
    $[6] = props;
    $[7] = t1;
    $[8] = type;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export interface InputBoxProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  characterLimit?: number;
}
export const InputBox = React.forwardRef<HTMLTextAreaElement, InputBoxProps>((t0, ref) => {
  const $ = _c(31);
  let characterLimit;
  let className;
  let defaultValue;
  let error;
  let id;
  let props;
  if ($[0] !== t0) {
    ({
      id,
      error,
      className,
      characterLimit,
      defaultValue,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = characterLimit;
    $[2] = className;
    $[3] = defaultValue;
    $[4] = error;
    $[5] = id;
    $[6] = props;
  } else {
    characterLimit = $[1];
    className = $[2];
    defaultValue = $[3];
    error = $[4];
    id = $[5];
    props = $[6];
  }
  let t1;
  if ($[7] !== defaultValue) {
    t1 = defaultValue?.toString() ?? "";
    $[7] = defaultValue;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const [value, setValue] = React.useState(t1);
  const t2 = error !== undefined && "border-destructive";
  let t3;
  if ($[9] !== className || $[10] !== t2) {
    t3 = cn("border-input placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-sm focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", t2, className);
    $[9] = className;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props) {
    t4 = event => {
      setValue(event.target.value);
      props.onChange?.(event);
    };
    $[12] = props;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== characterLimit || $[15] !== defaultValue || $[16] !== id || $[17] !== props || $[18] !== ref || $[19] !== t3 || $[20] !== t4) {
    t5 = <textarea id={id} ref={ref} className={t3} maxLength={characterLimit} defaultValue={defaultValue} {...props} onChange={t4} />;
    $[14] = characterLimit;
    $[15] = defaultValue;
    $[16] = id;
    $[17] = props;
    $[18] = ref;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== characterLimit || $[23] !== value) {
    t6 = characterLimit !== undefined && <p className="text-muted-foreground text-right text-sm">{value.length}/{characterLimit}</p>;
    $[22] = characterLimit;
    $[23] = value;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== error) {
    t7 = error !== undefined && <p className="text-destructive text-sm">{error}</p>;
    $[25] = error;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t8 = <div className="space-y-1">{t5}{t6}{t7}</div>;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
});
InputBox.displayName = "InputBox";